export const isNotFolderItemChild = (parentPath?: string, childPath?: string) => {
  if (!childPath) {
    return true;
  }

  const regex = new RegExp(`^${childPath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/`);
  return `${parentPath}/`.match(regex) === null;
};
